import { Theme, ThemeNameMap } from "@qendo/theme";
import { Stack } from "expo-router";
import { useMemo, useState } from "react";
import { Image, type ImageRequireSource, Pressable, StyleSheet, View } from "react-native";
import { RadioButton } from "react-native-paper";
import { Page } from "~/components/layout/Page";
import { Flex, Gap } from "~/constants/layout";
import { Radius, Space } from "~/constants/sizing";
import { useTheme } from "~/providers/ThemeProvider";
import { itemWidth, setWidthOnLayout } from "~/util/layout";

const ImageSourceMap: Record<Theme, ImageRequireSource> = {
    [Theme.light_blue]: require(`~/assets/theme/light_blue.png`),
    [Theme.dark_blue]: require(`~/assets/theme/dark_blue.png`),
    [Theme.light_pink]: require(`~/assets/theme/light_pink.png`),
    [Theme.dark_pink]: require(`~/assets/theme/dark_pink.png`),
};

export default function Appearance() {
    const { theme, colours, changeTheme, text, background } = useTheme();
    const [width, setWidth] = useState(300);
    const item_width = useMemo(() => itemWidth(Math.floor(width), 2), [width]);
    const onLayout = setWidthOnLayout(setWidth);

    return (
        <>
            <Stack.Screen options={{ title: "App Appearance" }} />
            <Page spacer>
                <RadioButton.Group onValueChange={(value) => changeTheme(value as Theme)} value={theme}>
                    <View style={[Flex.row, Flex.flex_2, Flex.wrap, Gap.sm]} onLayout={onLayout}>
                        {Object.values(Theme).map((t) => (
                            <Pressable
                                key={t}
                                style={[
                                    styles.item,
                                    background.primary,
                                    theme === t
                                        ? { borderColor: colours.check.selector }
                                        : { borderColor: colours.border.primary },
                                    { width: item_width },
                                ]}
                                onPress={() => changeTheme(t)}
                            >
                                <Image source={ImageSourceMap[t]} width={120} height={181} alt="" />
                                <RadioButton.Item
                                    value={t}
                                    label={ThemeNameMap[t]}
                                    color={colours.check.selector}
                                    uncheckedColor={colours.border.tertiary}
                                    style={[styles.radio]}
                                    labelVariant="labelLarge"
                                    labelStyle={[text.primary, styles.label]}
                                />
                            </Pressable>
                        ))}
                    </View>
                </RadioButton.Group>
            </Page>
        </>
    );
}

const styles = StyleSheet.create({
    item: {
        borderRadius: Radius.lg,
        padding: Space.md,
        gap: Space.sm,
        alignItems: "center",
        borderWidth: 2,
    },
    radio: {
        paddingTop: Space.xs,
        paddingBottom: Space.xs,
        paddingLeft: Space.xs,
        paddingRight: Space.xs,
        flexDirection: "column",
        gap: Space.sm,
    },
    label: {
        flexGrow: 0,
    },
});
